import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContentLayout from "../../components/mainContentLayout";
import PageHeader from "../../components/pageHeader";
import LoadingOverlay from "../../components/loadingOverlay";
import { API_BASE } from "../../config/apiConfig";
import { FiEye } from "react-icons/fi";
import { fromFirestoreTimestamp } from "../../utils/date";
import MiniNavigationTabs from "./miniNavigationTabs";

export default function PendingReviewPTLogPage() {
  const token = sessionStorage.getItem("access_token");
  const navigate = useNavigate();

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  async function loadPending() {
    setLoading(true);

    try {
      const params = new URLSearchParams({ month, year });
      const res = await fetch(`${API_BASE}/api/pt-pending-review?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();

      if (!data.success) {
        console.error("Failed to fetch pending logs:", data.message);
        return;
      }

      setLogs(data.logs || []);
    } catch (err) {
      console.error("Pending Review Error:", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadPending();
  }, [month, year]);

  return (
    <MainContentLayout>
      <PageHeader title="Pending Review" backTo="/dashboard" />
      <MiniNavigationTabs />

      <div className="w-full px-4">

        {/* Filters */}
        <div className="flex gap-4 items-center">
          <select
            value={month}
            onChange={(e) => setMonth(Number(e.target.value))}
            className="border border-gray-400 rounded px-2 py-2"
          >
            {Array.from({ length: 12 }).map((_, i) => (
              <option key={i} value={i + 1}>
                {new Date(0, i).toLocaleString("default", { month: "long" })}
              </option>
            ))}
          </select>

          <select
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
            className="border border-gray-400 rounded px-2 py-2"
          >
            {Array.from({ length: 5 }).map((_, i) => {
              const y = new Date().getFullYear() - i;
              return (
                <option key={y} value={y}>
                  {y}
                </option>
              );
            })}
          </select>
        </div>

        {/* Table */}
        {logs.length === 0 ? (
          <p className="mt-4">No pending logs for this period.</p>
        ) : (
          <table className="w-full border-collapse border border-gray-300 mt-4">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-2">#</th>
                <th className="border p-2">Player</th>
                <th className="border p-2">Date & Time</th>
                <th className="border p-2"></th>
              </tr>
            </thead>

            <tbody>
              {logs.map((log, idx) => {
                const jsDate = fromFirestoreTimestamp(log.date);
                const dateStr = jsDate?.toLocaleDateString("en-GB");
                const timeStr = jsDate?.toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                });

                return (
                  <tr key={log.id}>
                    <td className="border p-2 text-center">{idx + 1}</td>
                    <td className="border p-2">{log.fullName}</td>
                    <td className="border p-2">
                      {dateStr}, {timeStr}
                    </td>

                    <td className="border p-2 text-center">
                      <button
                        onClick={() =>
                          navigate(`/view-pt-log/${log.createdBy}/${log.id}`, { state: { from: "pending-review" }})
                        }
                        className="text-green-600 hover:text-green-800"
                        title="View Log"
                      >
                        <FiEye size={20} />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      <LoadingOverlay show={loading} text="Loading..." />
    </MainContentLayout>
  );
}
